const loading = state => state.loading;
const data = state => state.data;

export default {
  loading,
  data
};
